export const INVENTORY_ADJUSTMENT_ROOT = '/inventory-adjustment';

export const INVENTORY_ADJUSTMENT_ROUTES = {
  LIST_PAGE: INVENTORY_ADJUSTMENT_ROOT,
  DETAILS: `${INVENTORY_ADJUSTMENT_ROOT}/details`,
};
